module.exports = __webpack_public_path__ + "media/images/recipes/grillworst-4fe02e97bc7998c869588a0075e92308.pdf";